import React, { useEffect, useState } from "react";
import BlogDesktopCard from "./BlogDesktopCard";
import { BlogSkeleton } from "../BlogSkeleton";
import "./BlogDesktop.css";

const BlogDesktop = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch("/api/hashnode", { method: "GET" })
      .then((r) => r.json())
      .then((data) => {
        setPosts(data.publication?.posts?.edges?.map((e) => e.node) || []);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return (
      <div className="blog-desktop-wrapper">
        <BlogSkeleton />
        <BlogSkeleton />
        <BlogSkeleton />
      </div>
    );
  }

  if (error) return <pre>{error}</pre>;

  return (
    <div className="blog-desktop-wrapper">
      <h2 className="blog-text">Blog</h2>
      <section className="blog-desktop-container">
        {posts.map((node) => (
          <BlogDesktopCard key={node.id} blog={node} />
        ))}
      </section>
    </div>
  );
};

export default BlogDesktop;
